// GK-HUB: ERP command API client — sends commands to ERP via backend relay
/* global axios */

const buildUrl = (accountId, conversationId) =>
  `/api/v1/accounts/${accountId}/conversations/${conversationId}/erp_commands`;

export default {
  send(accountId, conversationId, command, extra = {}) {
    return axios.post(buildUrl(accountId, conversationId), {
      command,
      ...extra,
    });
  },
};
